import React from 'react';
import { motion } from 'framer-motion';
export function UniqueMechanism() {
  return <section className="py-24 bg-navy text-white relative overflow-hidden" data-id="element-125">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-126">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[150%] bg-navy-light rounded-full blur-3xl opacity-50 transform rotate-12" data-id="element-127"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-129">
          <span className="inline-block py-1 px-3 rounded-full bg-mint text-navy text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-130">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-131">
            Presentamos el Protocolo de Rescate Cognitivo 48h.
          </h2>
          <p className="text-lg md:text-xl text-mint-light leading-relaxed mb-8" data-id="element-132">
            A diferencia de los consejos típicos de "duerme más", este sistema
            ataca la raíz metabólica de la niebla mental.
          </p>
          <p className="text-lg md:text-xl text-white/90 leading-relaxed font-light" data-id="element-133">
            A través de una nutrición de impacto y un reseteo de
            neurotransmisores, eliminamos los frenos químicos que ralentizan tus
            neuronas, devolviéndote la claridad y la velocidad mental de forma
            natural.
          </p>
        </motion.div>
      </div>
    </section>;
}